import { render, staticRenderFns } from "./FeedDetail.vue?vue&type=template&id=261c1a6d&scoped=true&"
import script from "./FeedDetail.vue?vue&type=script&lang=js&"
export * from "./FeedDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeedDetail.vue?vue&type=style&index=0&id=261c1a6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c1a6d",
  null
  
)

export default component.exports